import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as CustomerRequestListMdls from '../../models/CustomerRequestBucketList';
import * as CustomerRequestMdls from '../../models/CustomerRequestBucket';
import * as CustomerRequestStore from '../../store/CustomerRequestList';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel, SaPhone } from '../Misc/SawinComponents';
import { useEffect } from 'react';

type MyProps =
    { CustomerRequests: CustomerRequestListMdls.CustomerRequestBucketListModel, SessionState: SessionModel } & typeof CustomerRequestStore.actionCreators;


const CustomerRequestList: React.FunctionComponent<MyProps> = (props: MyProps) => {

    interface ParamTypes {
        requestType: string
    }

    let { requestType } = useParams<ParamTypes>();

    useEffect(() => {
        props.loadRequest(requestType);      
    }, []);


    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.CustomerRequests.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Row>
                <Col className='center-align' xs={12}>
                    <Link to={{ pathname: "/RequestServiceEntry", state: { ServiceType: requestType } }}><Button className='top-screen-button'>New Request</Button></Link>
                </Col>
            </Row>
            {props.CustomerRequests.items.map((item, index) =>
                <Row key={index} >
                    <Col xs={12}>
                        <CustomerRequestListCard item={item}> </CustomerRequestListCard>
                    </Col>
                </Row>
            )}          
        </Container>
    );
}

const CustomerRequestListCard: React.FunctionComponent<{ item: CustomerRequestMdls.CustomerRequestBucketModel }> = (props: { item: CustomerRequestMdls.CustomerRequestBucketModel }) => {

    return (<Card className='customerRequest-card'>
        <CardHeader>
            <Row>
                <Col xs="8">
                    {props.item.contactName} <SaPhone UnformattedPhone={props.item.contactPhone} />
                </Col>
                <Col xs="4" className="right-align">
                    {props.item.requestStatus}
                </Col>
            </Row>
        </CardHeader>
        <CardBody>
            {props.item.descriptionOfWork }
        </CardBody>
    </Card>);
}

export default connect(
    (state: ApplicationState) => ({ CustomerRequests: state.customerRequestListState, SessionState: state.sessionState }),
    CustomerRequestStore.actionCreators)(CustomerRequestList as any);
